import Burger from "./Burger";
import './burger.css';

export default Burger;